import React from 'react';
import { Dropdown, IDropdownOption, mergeStyleSets } from '@fluentui/react';
import { boroondaraPalette } from '../../theme/boroondaraTheme';
import { ChoroplethMetricDef } from './types';

const p = boroondaraPalette;

interface ChoroplethControlsProps {
  topics: Record<string, ChoroplethMetricDef[]>;
  selectedTopic: string;
  selectedMetric: string;
  selectedYear: number;
  onTopicChange: (topic: string) => void;
  onMetricChange: (metric: string) => void;
  onYearChange: (year: number) => void;
}

const styles = mergeStyleSets({
  bar: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    padding: '10px 16px',
    background: '#FFFFFF',
    borderRadius: 4,
    border: `1px solid ${p.border}`,
    marginBottom: 12,
    flexWrap: 'wrap',
    '@media (max-width: 768px)': { gap: 8 },
  } as any,
  label: {
    fontSize: 11,
    fontWeight: 600,
    color: p.text3,
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    whiteSpace: 'nowrap',
  } as any,
  yearRow: {
    display: 'flex',
    gap: 4,
  },
  yearBtn: {
    padding: '4px 12px',
    borderRadius: 4,
    border: `1px solid ${p.borderSoft}`,
    background: '#fff',
    cursor: 'pointer',
    fontSize: 12,
    fontWeight: 600,
    color: p.text2,
    transition: 'all 0.15s',
  },
});

export default function ChoroplethControls({
  topics,
  selectedTopic,
  selectedMetric,
  selectedYear,
  onTopicChange,
  onMetricChange,
  onYearChange,
}: ChoroplethControlsProps) {
  const topicOptions: IDropdownOption[] = Object.keys(topics).map((t) => ({
    key: t,
    text: t.charAt(0).toUpperCase() + t.slice(1),
  }));

  const metricOptions: IDropdownOption[] = (topics[selectedTopic] || []).map((m) => ({
    key: m.key,
    text: m.label,
  }));

  return (
    <div className={styles.bar}>
      <span className={styles.label}>Census:</span>
      <Dropdown
        selectedKey={selectedTopic}
        options={topicOptions}
        onChange={(_, opt) => opt && onTopicChange(opt.key as string)}
        styles={{ dropdown: { minWidth: 140 }, title: { fontSize: 12 } }}
      />
      <Dropdown
        selectedKey={selectedMetric}
        options={metricOptions}
        onChange={(_, opt) => opt && onMetricChange(opt.key as string)}
        styles={{ dropdown: { minWidth: 180 }, title: { fontSize: 12 } }}
      />
      <div className={styles.yearRow}>
        {[2016, 2021].map((yr) => (
          <button
            key={yr}
            className={styles.yearBtn}
            style={
              selectedYear === yr
                ? { background: p.primary, color: '#fff', borderColor: p.primary }
                : undefined
            }
            onClick={() => onYearChange(yr)}
          >
            {yr}
          </button>
        ))}
      </div>
    </div>
  );
}
